export default (state = null) => state



// WEBPACK FOOTER //
// ./src/reducers/appConfigReducer.js